import { LanguageType } from "@/components/CodeEditor/types";

export const CodeExamples: Record<Exclude<LanguageType, "CURL" | "BASH">, string> = {
  PYTHON: `message = "These are my column names: "
columns = [column_name for column_name in data.keys()]
return message + str(columns)`,
  JAVASCRIPT: `const message = "These are my column names: ";
const columns = Object.keys(data);
return message + JSON.stringify(columns);`,
};
